<template>
<div>
  <v-text-field ref="input" :value="cvalue" :outlined="true" :suffix="suffix" @focus="change" @blur="blur" :label="label" @input="input" :filled="filled"  hide-details="auto"></v-text-field>
</div>
</template>

<script>
export default {
  name: "EditTextField",

  props: {
    format: [String, Number],
    value: Number,
    suffix: String,
    label: String,
    filled: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      mode: "show"
    }
  },

  computed: {
    cvalue() {
      if (this.mode == "show") {
        if (!this.value) {
          return;
        }

        return this.$n(this.value, this.format);
      } else if (this.value) {
        // german format
        let val = "" + this.value;
        val = val.replace(/\./g, ',');
        return val;
      } else {
        return this.value;
      }
    },

    type() {
      if (this.mode == "edit") {
        return "text";
      }

      return "text";
    }
  },

  methods: {
    input(val) {
      /*
      // german format
      1234,56  -> 1234,56
      12,34,56 -> 12,34
      1234.56  -> 1234,56
      12,34.56 -> 12,34
      */

      val = val.replace(/\./g, ',');
      val = val.replace(/[^\d,-]/g, '');

      const re = /^(-)?[0-9]+(,)?([0-9]+)?$/g;

      //let lazyValue = val;

      const match = re.exec(val);
      let n = null;
      if (match) {
        val = match[0];
      } else {
        val = ("" + val).replace(/\./g, ",");
      }

      //lazyValue = val;
      val = val.replace(/,/g, ".");

      n = parseFloat(val);
      if (Number.isNaN(n)) {
        n = null;
      }

      // https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VTextField/VTextField.ts
      //const comp = this.$refs.input;
      //comp.lazyValue = lazyValue;

      this.$emit("input", n);
    },

    change() {
      if (this.mode == "show") {
        this.mode = "edit";
      }
    },

    blur() {
      if (this.mode == "edit") {
        this.mode = "show";
      }
    }
  }
};
</script>
